import { View, Text, StyleSheet } from "react-native";
import InputText from "./InputText";
import { Button, useTheme } from "react-native-paper";
import { useForm, Controller } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import confirmEmailSchema from "../schemas/confirmEmailSchema";
import { useState } from "react";
import { showMessage } from "react-native-flash-message";
import useApi from "../hooks/useAPI";

type inputData = {
	otp: string;
};

type Props = {
	email: string;
	emailSended: boolean;
	navigation: any;
};

const ConfirmEmail = ({ email, emailSended, navigation }: Props) => {
	const { colors } = useTheme();
	const [loading, setLoading] = useState(false);
	const [anotherLoading, setAnotherLoading] = useState(false);
	const api = useApi();

	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<inputData>({
		resolver: joiResolver(confirmEmailSchema),
	});

	const onSubmit = async (dataOfInput: inputData) => {
		setLoading(true);
		try {
			const { data } = await api.redefinePassword.verifyOtp(
				email,
				dataOfInput.otp
			);
			showMessage({ type: "success", message: "Autenticação bem-sucedida." });
			navigation.navigate("RecreatePassword", { email, otp: data.reset_otp });
		} catch (e) {
			showMessage({ type: "danger", message: "Autenticação falhou." });
		} finally {
			setLoading(false);
		}
	};

	return (
		<View style={{ marginTop: 30 }}>
			<Text style={styles.header}>Insira o código</Text>
			<Text style={styles.text}>
				O código de segurança foi enviado para o seu e-mail atrelado ao seu
				cadastro.
			</Text>
			<Controller
				control={control}
				rules={{
					required: true,
				}}
				render={({ field: { onChange, onBlur, value } }) => (
					<InputText
						placeholder="Digite o código recebido"
						style={[
							styles.input,
							{
								borderColor: errors.otp
									? colors.error
									: colors.inputBackgroundColor,
							},
						]}
						onBlur={onBlur}
						onChange={onChange}
						value={value}
						selectionColor={colors.primary}
						textColor={errors.otp ? colors.error : colors.text}
						placeholderTextColor={errors.otp ? colors.error : colors.text}
						disabled={!emailSended || loading}
					/>
				)}
				name="otp"
			/>
			<Button
				onPress={async () => {
					setAnotherLoading(true);
					const response = await api.redefinePassword.verifyEmail(email);
					console.log({ response });

					if (response.status === 200)
						showMessage({
							type: "success",
							message:
								"Código reenviado.\n" +
								`Verifique a caixa de entrada de: ${email}`,
						});
					setAnotherLoading(false);
				}}
				style={styles.didntRecieveCode}
				disabled={anotherLoading}
			>
				Não recebeu o código?
			</Button>
			<Button
				style={styles.btn}
				labelStyle={styles.btnText}
				mode="contained"
				disabled={!emailSended || loading}
				onPress={handleSubmit(onSubmit)}
			>
				Enviar código
			</Button>
		</View>
	);
};

export default ConfirmEmail;

const styles = StyleSheet.create({
	root: {
		flex: 1,
		backgroundColor: "#fff",
		paddingHorizontal: "5%",
		paddingTop: 16,
	},

	header: {
		fontWeight: "600",
		fontSize: 32,
	},
	input: {
		marginTop: 30,
		alignSelf: "center",
		width: "100%",
		zIndex: 0,
		borderWidth: 1,
	},
	btn: {
		marginTop: 10,
		borderRadius: 25,
		width: "100%",
		height: 50,

		alignSelf: "center",
	},
	btnText: {
		color: "#fff",
		fontSize: 15,
		lineHeight: 30,
		width: "90%",
	},
	text: {
		letterSpacing: 0.25,
		color: "#999999",
		lineHeight: 20,
		fontWeight: "400",
		fontSize: 15,
	},
	didntRecieveCode: {
		alignSelf: "flex-end",
	},
});
